angular.module('picmonicng').factory('affiliateResource', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/affiliate',
      {},
      {
        update: { method: 'PUT' },
      }
    );
  },
]);
